'use strict';

/**
 * Collection of constants related with loading spinner component.
 * @typedef SpinnerConfig
 * @property {number} DEFAULT - spinner default type
 */

/**
 * @type {SpinnerConfig}
 */
module.exports = {
    DEFAULT: 0
};
